import 'react-router';

export const ROUTES = {
    HOME: '/',
    DEALS: '/deals',
    DEAL: '/deals/:id',
    POSTPONED_DEALS: '/postponed',
    LOST_DEALS: '/lost',
    IN_WORK_OR_FINISHED_DEALS: '/in-work-or-finished',
    TASKS: '/tasks',
    LEADS: '/leads',
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    ORDERS: '/orders',
} as const;

export interface BackNavigationState {
    fromRoute: string;
}

export type PathParams = {
    [ROUTES.DEAL]: {
        id: string;
    };
};

type RoutePage<Params extends Record<string, string | undefined> = Record<string, never>> = {
    params: Params;
};

declare module 'react-router' {
    interface Register {
        pages: {
            [ROUTES.HOME]: RoutePage;
            [ROUTES.DEALS]: RoutePage;
            [ROUTES.DEAL]: RoutePage<PathParams[typeof ROUTES.DEAL]>;
            [ROUTES.POSTPONED_DEALS]: RoutePage;
            [ROUTES.LOST_DEALS]: RoutePage;
            [ROUTES.IN_WORK_OR_FINISHED_DEALS]: RoutePage;
            [ROUTES.TASKS]: RoutePage;
            [ROUTES.LEADS]: RoutePage;
            [ROUTES.DASHBOARD]: RoutePage;
            [ROUTES.PROFILE]: RoutePage;
            [ROUTES.ORDERS]: RoutePage;
        };
    }
}
